import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gig'
})
export class GigPipe implements PipeTransform {

  transform(value: number) {

    return (Math.round(100 * value / (1024 * 1024 * 1024)) / 100).toString();
  }

}
